import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';
import {DpDatePickerModule} from 'ng2-jalali-date-picker';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {JalaliPipe} from './pipes/jalali.pipe';
import {JalaliDateTimePipe} from './pipes/jalali-date-time.pipe';
import {NotificationsService} from './services/notifications.service';
import {ViewElementComponent} from './components/view-element/view-element.component';
import {ChartFlipComponent} from './components/chart-flip/chart-flip.component';
import {UnauthorizedAccessComponent} from './components/errors-handling/unauthorized-access/unauthorized-access.component';
import {FormService} from './services/form.service';
import {NotFoundComponent} from './components/errors-handling/not-found/not-found.component';
import {NpaDateTimePickerComponent} from './components/npa-date-time-picker/npa-date-time-picker.component';
import {ConfirmationService} from './services/confirmation.service';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {FileService} from './services/file.service';
import {NPA_DATE_FORMATS} from './utils/date.util';
import {TranslateService} from './services/translate.service';
import {FileUploaderComponent} from './components/file-uploader/file-uploader.component';
import {TitleValueWidgetComponent} from './components/title-value-widget/title-value-widget.component';
import {
    MAT_DATE_FORMATS,
    MatAutocompleteModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSnackBarModule,
    MatTableModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule
} from '@angular/material';
import {CommonModule} from '@angular/common';
import {MaterialModule} from '../../../material.module';
import {FlexLayoutModule} from '@angular/flex-layout';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {CKEditorModule} from '@ckeditor/ckeditor5-angular';
import {ContextMenuComponent} from './components/context-menu/context-menu.component';
import {SnackbarMessageComponent} from './components/snackbar-message/snackbar-message.component';
import {NotificationDialogComponent} from './components/notification-dialog/notification-dialog.component';
import {ConfirmationDialogComponent} from './components/confirmation-dialog/confirmation-dialog.component';
import {BreadcrumbComponent} from './components/breadcrumb/breadcrumb.component';
import {RouterModule} from '@angular/router';
import {FormValidationService} from './services/form-validation/form-validation.service';
import {SafeHtmlPipe} from './pipes/safeHtml.pipe';
import {SortService} from './services/sort.service';
import {DynamicWidgetComponent} from './components/dynamic-widget/dynamic-widget.component';
import {NpaDateTimeComponent} from './components/npa-date-time/npa-date-time.component';
import {NpaTimeComponent} from './components/npa-time/npa-time.component';
import {MatPaginatorModule} from '@angular/material/paginator';
import {NpaDateComponent} from './components/npa-date/npa-date.component';
import {FileUploaderShortComponent} from './components/file-uploader-short/file-uploader-short.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import {MatBadgeModule} from '@angular/material/badge';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatStepperModule} from '@angular/material/stepper';
import {FileManagerModule} from 'npa-fm';
import {RemarkDialogComponent} from './components/remark-dialog/remark-dialog.component';
import {RemarkModule} from 'npa-ums';
import {JalaliTimePipe} from './pipes/jalali-time.pipe';
import {AvrcsSearchDialogComponent} from './components/avrcs-search-dialog/avrcs-search-dialog.component';
import {environment} from '../../../environments/environment';
import {AvrcsSearchDialogService} from './components/avrcs-search-dialog/avrcs-search-dialog.service';
import {NgScrollbarModule} from 'ngx-scrollbar';
import {RemarkService} from './services/remark.service';
import {InactiveRouteDialogComponent} from './components/inactive-route/inactive-route.dialog.component';
import {ProcurementProcessFlowComponent} from '../procurement-process/components/procurement-process-flow/procurement-process-flow.component';
import {WebNotificationsService} from './services/web-notifications.service';
import {DateTimeOptimizerPipe} from './pipes/date-time-optimizer.pipe';
import {NotificationComponent} from './components/notification/notification.component';
import { RejectionReasonDialogComponent } from './components/rejection-reason-dialog/rejection-reason-dialog.component';
import { NonElectronicCountdownComponent } from './components/non-electronic-countdown/non-electronic-countdown.component';
import {NonElectronicCountdownService} from './components/non-electronic-countdown/non-electronic-countdown.service';
import { FileDownloaderComponent } from './components/npa-file-downloader/npa-file-downloader.component';
import { FileDownloaderDialogComponent } from './components/file-uploader/file-downloader-dialog/file-downloader-dialog.component';
import { ShowParticipantsDialogComponent } from './components/show-participants-dialog/show-participants-dialog.component';
import { VendorTaxClearanceDialogComponent } from './components/vendor-tax-clearance-dialog/vendor-tax-clearance-dialog.component';
import { ViewDialogComponent } from './components/vendor-tax-clearance-dialog/view-dialog/view-dialog.component';
import { LogDialogComponent } from './components/vendor-tax-clearance-dialog/log-dialog/log-dialog.component';
import { VendorTaxClearanceService } from './components/vendor-tax-clearance-dialog/vendor-tax-clearance.service';
import { NgxBarcodeModule } from "ngx-barcode";
import { LegalDocFileUploaderComponent } from './components/legal-doc-file-uploader/legal-doc-file-uploader.component';
import { LegalFileDownloaderComponent } from './components/legal-doc-file-uploader/legal-file-downloader/legal-file-downloader.component';
import { LegalDocFileUploaderServices } from './components/legal-doc-file-uploader/legal-doc-file-uploader.service';
import { LegalFileDownloaderServices } from './components/legal-doc-file-uploader/legal-file-downloader/legal-file-downloader.service';
import { ChartComponent } from './components/chart/chart.component';

@NgModule({
    imports: [
        MatIconModule,
        MatCheckboxModule,
        MatAutocompleteModule,
        MatDividerModule,
        CommonModule,
        FormsModule,
        MatToolbarModule,
        MatTooltipModule,
        MatButtonModule,
        MatInputModule,
        MatDialogModule,
        MatSnackBarModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatCardModule,
        MaterialModule,
        MatMomentDateModule,
        MatTableModule,
        ReactiveFormsModule,
        MatMenuModule,
        MatChipsModule,
        DpDatePickerModule,
        HttpClientModule,
        MatPaginatorModule,
        DragDropModule,
        FlexLayoutModule,
        CKEditorModule,
        MatRadioModule,
        MatSlideToggleModule,
        MatButtonToggleModule,
        MatBadgeModule,
        MatExpansionModule,
        MatTreeModule,
        MatStepperModule,
        MatSlideToggleModule,
        MatFormFieldModule,
        FileManagerModule.forRoot(environment),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        RouterModule,
        MatListModule,
        RemarkModule.forRoot(environment),
        NgScrollbarModule,
        NgxBarcodeModule
        // ActionMenuWidgetModule
    ],
    declarations: [
        SnackbarMessageComponent,
        NotificationDialogComponent,
        JalaliPipe,
        JalaliDateTimePipe,
        JalaliTimePipe,
        DateTimeOptimizerPipe,
        ViewElementComponent,
        ChartFlipComponent,
        UnauthorizedAccessComponent,
        NotFoundComponent,
        NpaDateTimePickerComponent,
        ConfirmationDialogComponent,
        FileUploaderComponent,
        FileDownloaderDialogComponent,
        FileUploaderShortComponent,
        TitleValueWidgetComponent,
        ContextMenuComponent,
        BreadcrumbComponent,
        ProcurementProcessFlowComponent,
        SafeHtmlPipe,
        DynamicWidgetComponent,
        NpaDateTimeComponent,
        NpaTimeComponent,
        NpaDateComponent,
        // electronic CountdownComponent,
        NotificationComponent,
        RemarkDialogComponent,
        AvrcsSearchDialogComponent,
        ShowParticipantsDialogComponent,
        InactiveRouteDialogComponent,
        // electronic BiddingOpportunitiesDialogComponent,
        RejectionReasonDialogComponent,
        NonElectronicCountdownComponent,
        FileDownloaderComponent,
        LegalDocFileUploaderComponent,
        LegalFileDownloaderComponent,
        VendorTaxClearanceDialogComponent,
        ViewDialogComponent,
        LogDialogComponent,
        ChartComponent,
    ],
    exports: [
        CommonModule,
        MatDatepickerModule,
        FormsModule,
        ReactiveFormsModule,
        MatProgressBarModule,
        MatMomentDateModule,
        DpDatePickerModule,
        MatChipsModule,
        MatDividerModule,
        JalaliPipe,
        MaterialModule,
        JalaliDateTimePipe,
        JalaliTimePipe,
        DateTimeOptimizerPipe,
        ViewElementComponent,
        ChartFlipComponent,
        UnauthorizedAccessComponent,
        NpaDateTimePickerComponent,
        TranslateModule,
        FileUploaderComponent,
        FileDownloaderDialogComponent,
        FileUploaderShortComponent,
        TitleValueWidgetComponent,
        HttpClientModule,
        FlexLayoutModule,
        DragDropModule,
        ContextMenuComponent,
        MatAutocompleteModule,
        CKEditorModule,
        MatRadioModule,
        BreadcrumbComponent,
        SafeHtmlPipe,
        ProcurementProcessFlowComponent,
        DynamicWidgetComponent,
        MatPaginatorModule,
        MatTableModule,
        NpaDateTimeComponent,
        NpaTimeComponent,
        MatListModule,
        NpaDateComponent,
        MatSlideToggleModule,
        MatButtonToggleModule,
        MatBadgeModule,
        MatExpansionModule,
        MatTreeModule,
        // electronic CountdownComponent,
        NotificationComponent,
        FileManagerModule,
        MatStepperModule,
        RemarkDialogComponent,
        RemarkModule,
        AvrcsSearchDialogComponent,
        ShowParticipantsDialogComponent,
        NgScrollbarModule,
        InactiveRouteDialogComponent,
        // electronic BiddingOpportunitiesDialogComponent,
        NonElectronicCountdownComponent,
        FileDownloaderComponent,
        LegalDocFileUploaderComponent,
        LegalFileDownloaderComponent,
        VendorTaxClearanceDialogComponent,
        ViewDialogComponent,
        LogDialogComponent,
        ChartComponent
    ],
    entryComponents: [
        SnackbarMessageComponent,
        NotificationDialogComponent,
        ConfirmationDialogComponent,
        RemarkDialogComponent,
        AvrcsSearchDialogComponent,
        ShowParticipantsDialogComponent,
        InactiveRouteDialogComponent,
        // electronic BiddingOpportunitiesDialogComponent,
        RejectionReasonDialogComponent,
        FileDownloaderDialogComponent,
        VendorTaxClearanceDialogComponent,
        ViewDialogComponent,
        LogDialogComponent,
        LegalFileDownloaderComponent,
    ],
    providers: [
        NotificationsService,
        AvrcsSearchDialogService,
        FormService,
        {
            provide: MAT_DATE_FORMATS,
            useValue: NPA_DATE_FORMATS
        },
        ConfirmationService,
        FileService,
        TranslateService,
        FormValidationService,
        SortService,
        JalaliPipe,
        JalaliDateTimePipe,
        JalaliTimePipe,
        // electronic CountdownService,
        RemarkService,
        WebNotificationsService,
        NonElectronicCountdownService,
        VendorTaxClearanceService,
        LegalDocFileUploaderServices,
        LegalFileDownloaderServices,
        FileUploaderComponent
    ]
})


export class SharedModule {
}

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, '../../assets/i18n/', '.json');
}
